<template lang="html">

<div class="upload-img">
  <el-image
    v-for="(item,inx) in urlArr"
    :key='inx'
    style="width: 100px; height: 100px"
    :src="item.url"
    :preview-src-list="item.list">
  </el-image>
</div>

</template>

<script>
import { getToken } from '@/utils/auth';
import { getFileToken,getViewKey,detFile } from '@/api/account';
export default {
    name:'imgsUpload',
    props:['files','listType','limit','tips'],
    data(){
        return{
            fileList: [],
            postDat:'',

            viewDat:'',
            fileMap:{},
            fileStore:[],

            urlArr:[]
        }
    },
    watch:{
        files:function(e){
            this.filesSet(e);
        }
    },
    methods:{
        filesSet:function(e){
            if(this.fileList.length === 0 && e && this.viewDat){
               var files = JSON.parse(e);
               this.urlArr = [];
               files.forEach(item => {
                   let temp = {};
                   temp.url = this.viewDat.imagePreUrl + '/id/' + item.id + '/token/' + this.viewDat.token;
                   temp.list = [temp.url];
                   this.urlArr.push(temp)
               })
               this.fileList = files;
               this.fileStore = files;
            }
        },
        beforeUpload:function(file){
            var isImage = file.type.split('\/')[0] === 'image';

            var isLt100M = file.size / 1024 / 1024 <= 2;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 2 MB!');
            }

            if(!isImage){
                this.$message.error('只能上传格式为 jpg/jpeg/png/pdf/gif 的文件');
            }

            if(isLt100M && isImage){
               return true;
            }
        },

        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },

        handleSuccess:function(res,file,fileList){
            var newMap = {};
            fileList.forEach(item => {
                if(item.id){
                    newMap[item.uid] = item.id;
                }else if(this.fileMap[item.uid]){
                    newMap[item.uid] = this.fileMap[item.uid];
                }
            });
            newMap[file.uid] = this.postDat.key;
            this.fileMap = newMap;
            this.flieStoreSet(fileList);
        },

        handleRemove:function(file,fileList){
            detFile({id:file.id || this.fileMap[file.uid],fileType:1});
            this.flieStoreSet(fileList);
        },

        flieStoreSet:function(fileList){
            this.fileStore = [];
            fileList.forEach(item => {
                var file = {
                    name:item.name,
                    id:this.fileMap[item.uid],
                }
                this.fileStore.push(file);
            })
            this.$emit('fileChange',this.fileStore);
        }

    },
    created:function(){

        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl:res.imagePreUrl,
                token:res.token
            };
            this.filesSet(this.files);
        })
    }
}
</script>

<style lang="css" scoped>

.el-image{
   margin: 5px;
}

</style>



// WEBPACK FOOTER //
// imgsUpload.vue?0d7cc442